import { FC, useState } from 'react';

import { IUserEditModalProps } from 'components/Access/Modals/UserDetailsModal';
import UserTable from 'components/Access/Tables/UserTable';
import { Header } from 'components/Header/Header';

import AddUserButton from './AddUserButton';

const UsersScreen: FC = () => {
  const [userDetailsModalProps, setUserDetailsModalProps] =
    useState<IUserEditModalProps>();
  const [reload, setReload] = useState(false);

  const triggerReload = () => {
    setReload((prev) => !prev);
  };

  const handleAddUser = () => {
    setUserDetailsModalProps({
      onClose: () => {
        setUserDetailsModalProps(undefined);
      },
      onSuccess: triggerReload,
    });
  };

  return (
    <div className="w-full">
      <Header className="w-full">
        <AddUserButton onClick={handleAddUser} />
      </Header>
      <div className="w-full p-6 pb-8 pt-8 mx-auto">
        <UserTable
          reload={reload}
          userDetailsModalProps={userDetailsModalProps}
          triggerReload={triggerReload}
          setUserDetailsModalProps={setUserDetailsModalProps}
        />
      </div>
    </div>
  );
};

export default UsersScreen;
